import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Grid,
    IconButton,
    Select,
    MenuItem,
    SelectChangeEvent
    } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LOCAL_CONSTANT } from "../../Const";
import {
    setSaveStatus,
    setTradeAreaRealityFlag
} from "../../../features/longPageSlice";
import {
    updateCell,
    setTradeAreaMpData
} from "../../../features/tradeAreaSlice";
import { useUserContext } from "../../../user-provider";
import { lineBreak } from "../../ResearchReport/TradeArea";
import { useUtilityContext } from "../../../utility-provider";
import { apiRequest } from "../../../api/ApiCall";
import { userLogging } from "../../../utility/firestore";
import {
    calculateColumnTotal,
    divideIfNotZero,
    locationFunc,
    populationFunc,
    populationRealitySurveyFunc,
    tradeAreaDensityFunc,
    mpData
} from "./TradeAreaFunction";
import {
    labelHeaderStyle,
    labelStyle,
    table12Column,
    table5Column,
    table6Column,
    tableCellStyle,
} from "./TradeAreaStyle";
import { setPermissionFunc } from "../../components/PermissionFunc";
import {
    TradeAreaMpDataTableTypeList,
    initTradeAreaMpDataTableTypeList,
    tradeAreaMpDataStringTypeList,
    TradeAreaMpDataBooleanTypeList,
    initTradeAreaMpDataCommentTextFieldObj,
    initTradeAreaMpDataReadOnlyObj
} from "../../../data/type";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import EditIcon from "@mui/icons-material/Edit";
import DeficiencyCommentRegistModal from "../../components/DeficiencyCommentRegistModal";
import {
    chatBubbleErrorSx,
    chatBubbleIconSx,
    editIconCircleSx,
    iconHover,
} from "../../components/ChatBubbleAndEditIconStyle";
import {
    BGDefaultColor,
    BGChangeColor,
    BGDisabledColor,
} from "../../../data/table";
import { changeTradeAreaColor } from "../../../data/tableFunc";

const table3Column = {
    width: "288px",
    marginBottom: "20px",
    border: "1px solid black",
};

const table10Column = {
    width: "962px",
    marginBottom: "20px",
    border: "1px solid black",
};

const table13Column = {
    width: "1250px",
    marginBottom: "20px",
    border: "1px solid black",
};

// TextFieldのスタイル調整
const TextFieldSx = {
    "& .MuiOutlinedInput-input.Mui-disabled": {
        textAlign: "center", //入力した値を中央寄せ
    },
};

//ユーザー権限種別が活性の場合にテキストフィールドの色を変える
const tableActiveInactiveTextSx = (
    isUserType: boolean,
    objRrBranchLog: any,
    labelName: string,
    value: any,
    tradeAreaSeq: string
) => {
    return {
        "& .MuiOutlinedInput-input": {
            textAlign: "center", //入力した値を中央寄せ
            color: changeTradeAreaColor(
                isUserType,
                objRrBranchLog,
                LOCAL_CONSTANT.NAVI.TRADE_AREA,
                labelName,
                tradeAreaSeq,
                "trade_area_seq"
            ),
        },
        backgroundColor: changeBGColor(isUserType, value),
    };
};

//背景色判定
export const changeBGColor = (isUserType: boolean, value: any) => {
    if (isUserType) {
        return BGDisabledColor;
    } else if (value) {
        return BGChangeColor;
    }
    return BGDefaultColor;
};

//③勾配加味徒歩5分商圏デ ヘッダー
const GradientWalk5MinHeaderFirstColumns = [
    //コロンで改行
    { label: "商圏:世帯数:(世帯)" },
    { label: "単身:世帯数:(世帯)" },
    { label: "単身比率:(%)" },
    { label: "人口:(人)" },
    { label: "20代:計(人)" },
    { label: "20代:比率(%)" },
    { label: "30代:計(人)" },
    { label: "30代:比率(%)" },
    { label: "50歳以上:計(人)" },
    { label: "50歳以上:比率(%)" },
    { label: "65歳以上:計(人)" },
    { label: "65歳以上:比率(%)" },
];

const GradientWalk5MinHeaderSecondColumns = [
    //コロンで改行
    { label: "事業所:(箇所)" },
    { label: "従業員数:(人)" },
    { label: "引分:事業所:(箇所)" },
    { label: "引分:従業員:(人)" },
    { label: "差引:事業所:(箇所)" },
    { label: "差引:従業員:(人)" },
];

const GradientWalk5MinHeaderThirdColumns = [
    //コロンで改行
    { label: "～300万:(%)" },
    { label: "～500万:(%)" },
    { label: "～700万:(%)" },
    { label: "～1000万:(%)" },
    { label: "1000万～:(%)" },
];

//④商圏データ ヘッダー
// tradeAreaRealityFlagが0の場合、実査項目なしの表示ヘッダー 
// tradeAreaRealityFlagが1の場合、実査項目ありの表示ヘッダー
const TaradeAreaHeaderColumns = [
    //コロンで改行
    { colName: "townDistrict", label: "町丁字", tradeAreaRealityFlag:["0", "1"] },
    { colName: "residences_count", label: "世帯数:(世帯)" , tradeAreaRealityFlag:["0", "1"] },
    { colName: "reality_survey_household_count", label: "実査:世帯数" , tradeAreaRealityFlag:["1"] },
    { colName: "singleHousehold", label: "単身世帯:(世帯)", tradeAreaRealityFlag:["0", "1"] },
    { colName: "population", label: "人口:(人)", tradeAreaRealityFlag:["0", "1"] },
    { colName: "ageGroup20", label: "20代:(人)", tradeAreaRealityFlag:["0", "1"] },
    { colName: "ageGroup30", label: "30代:(人)", tradeAreaRealityFlag:["0", "1"] },
    { colName: "ageGroup50", label: "50代:(人)", tradeAreaRealityFlag:["0", "1"] },
    { colName: "ageGroup65More", label: "65上:(人)", tradeAreaRealityFlag:["0", "1"] },
    { colName: "office", label: "事業所:(箇所)" , tradeAreaRealityFlag:["0", "1"] },
    { colName: "employees", label: "従業員:(人)", tradeAreaRealityFlag:["0", "1"] },
    { colName: "reality_survey_office", label: "実査:事業所", tradeAreaRealityFlag:["1"]},
    { colName: "reality_survey_employed_workers", label: "実査:就業者", tradeAreaRealityFlag:["1"] },
];

//④商圏データ 合計
const TaradeAreaSumColumns = [
    // コロンで改行
    { colName: "residences_count", label: "世帯数" },
    { colName: "reality_survey_household_count", label: "実査:世帯数" },
    { colName: "singleHousehold", label: "単身世帯" },
    { colName: "population", label: "人口" },
    { colName: "ageGroup20", label: "20代" },
    { colName: "ageGroup30", label: "30代" },
    { colName: "ageGroup50", label: "50代" },
    { colName: "ageGroup65More", label: "65上" },
    { colName: "office", label: "事業所" },
    { colName: "employees", label: "従業員" },
    { colName: "reality_survey_office", label: "実査:事業所" },
    { colName: "reality_survey_employed_workers", label: "実査:就業者" },
];

export interface TradeAreaProps {
    props: {};
}

export const TradeAreaMpData: React.FC<TradeAreaProps> = ({ props }) => {
    //③勾配加味徒歩5分商圏と④商圏データの実査項目 Redux
    const listMpData = useAppSelector((state) => state.tradeArea.mpDataList);
    //商圏ページ ④商圏データ値をReduxへ登録する前に保存
    const [tradeArea, setTradeArea] = useState<TradeAreaMpDataTableTypeList[]>(initTradeAreaMpDataTableTypeList);
    //パラメーターオブジェクト
    const objLongPageSaveStatus = useAppSelector((state) => state.longPage.saveStatus);
    //調査書基本
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);
    //ロングページオブジェクト 候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //不備コメントモーダル内、TextFieldのコメント
    const [tradeAreaMpDataCommentTextFieldObj, setTradeAreaMpDataCommentTextFieldObj] = useState<tradeAreaMpDataStringTypeList>(initTradeAreaMpDataCommentTextFieldObj);
    // 項目値を編集可能にするステータスの型定義
    const [tradeAreaMpDataReadOnlyObj, setTradeAreaMpDataReadOnlyObj] = useState<TradeAreaMpDataBooleanTypeList>(initTradeAreaMpDataReadOnlyObj);
    //不備コメントモーダルラベル名（プルダウン、ラジオボタン用）
    const [labelNameStr, setLabelNameStr] = useState<string>("");
    //不備コメントモーダル開閉フラグ（プルダウン、ラジオボタン用）
    const [deficiencyComentModalFlag, setDeficiencyComentModalFlag] = useState(false);
    // 表示色変更用BQログデータ
    const objRrBranchLog = useAppSelector((state) => state.longPage.rrBranchLog);
    // 不備コメントリスト
    const listDeficiencyComment = useAppSelector((state) => state.deficiencyComment);

    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const [userType, setUserType] = useState<string>("");
    const user = useUserContext();
    // コードマスタ ありなし
    const [yesnoneKana, setYesnoneKana] = useState<any>();

    //ユーザー取得タイミングによる画面制御
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    // 人口関数の結果を格納する変数
    let populationResult = 0;

    //④商圏データ 実査の項目値を更新
    const handleCellChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        rowIndex: number,
        labelName: string,
    ) => {
        const updateRowData = [...tradeArea];
        const targetValue = e.target.value;
        if (/^$|^0$|^[1-9]\d*$/.test(targetValue)) {
            //空文字列、0、または正の整数のみ可能
            updateRowData[rowIndex] = {
                ...updateRowData[rowIndex],
                [labelName]: targetValue,
            };
            setTradeArea(updateRowData);
        }
        //更新フラグ
        if (!objLongPageSaveStatus.TradeArea)
            dispatch(
                setSaveStatus({ ...objLongPageSaveStatus, TradeArea: true })
            );
    };

    //④商圏データ 実査の項目値を更新後、計算処理
    const handleCellBlur = (
        e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
        rowIndex: number,
        labelName: string,
        realityFlag: string //実査ありのとき更新
    ) => {
        const updateRowData = [...tradeArea];
        const targetValue = e.target.value;
        //実査世帯数が空白の場合の戻し処理
        if (
            labelName === "reality_survey_household_count" &&
            targetValue === "" &&
            realityFlag === "1"
        ) {
            populationResult = Number(
                populationFunc(
                    Number(listMpData[rowIndex].residences_count),
                    Number(listMpData[rowIndex].popilation_total),
                    Number(listMpData[rowIndex].household_count)
                )
            );
            dispatch(
                updateCell({
                    ...updateRowData[rowIndex],
                    id: Number(rowIndex),
                    reality_survey_household_count: targetValue,
                    singleHousehold: Number(listMpData[rowIndex].residences_count) * (Number(listMpData[rowIndex].single_household_ratio) / 100),
                    population: populationResult,
                    ageGroup20: populationResult * (Number(listMpData[rowIndex].age_group_20ratio) / 100),
                    ageGroup30: populationResult * (Number(listMpData[rowIndex].age_group_30ratio) / 100),
                    ageGroup50: populationResult * (Number(listMpData[rowIndex].age_group_50moreratio) / 100),
                    ageGroup65More: populationResult * (Number(listMpData[rowIndex].age_group_65moreratio) / 100),
                })
            );
        } //更新処理
        else if (
            labelName === "reality_survey_household_count" &&
            realityFlag === "1"
        ) {
            populationResult = Number(
                populationRealitySurveyFunc(
                    Number(targetValue), //人口 実査世帯数を用いて計算した人口
                    listMpData[rowIndex].residences_count,
                    listMpData[rowIndex].popilation_total,
                    listMpData[rowIndex].household_count
                )
            );
            dispatch(
                updateCell({
                    ...updateRowData[rowIndex],
                    id: Number(rowIndex),
                    reality_survey_household_count: targetValue, //実査世帯数
                    singleHousehold: Number(targetValue) * (Number(listMpData[rowIndex].single_household_ratio) / 100), //単身世帯 実査世帯数 *（mp_data.単独世帯数の比率/100）
                    population: populationResult, //人口 実査世帯数を用いて計算した人口
                    ageGroup20: populationResult * (Number(listMpData[rowIndex].age_group_20ratio) / 100), //20代 実査世帯数を用いて計算した人口 *（mp_data.20代比率/100）
                    ageGroup30: populationResult * (Number(listMpData[rowIndex].age_group_30ratio) / 100), //30代 実査世帯数を用いて計算した人口 *（mp_data.30代比率/100）
                    ageGroup50: populationResult * (Number(listMpData[rowIndex].age_group_50moreratio) / 100), //50代 実査世帯数を用いて計算した人口 *（mp_data.50才以上比率/100）
                    ageGroup65More: populationResult * (Number(listMpData[rowIndex].age_group_65moreratio) / 100), //65上 実査世帯数を用いて計算した人口 *（mp_data.65才以上比率/100
                })
            );
        } else if (
            labelName === "reality_survey_office" &&
            realityFlag === "1"
        ) {
            //実査事業所
            dispatch(
                updateCell({
                    ...updateRowData[rowIndex],
                    id: Number(rowIndex),
                    reality_survey_office: targetValue,
                })
            );
        } else if (
            labelName === "reality_survey_employed_workers" &&
            realityFlag === "1"
        ) {
            //実査就業者
            dispatch(
                updateCell({
                    ...updateRowData[rowIndex],
                    id: Number(rowIndex),
                    reality_survey_employed_workers: targetValue,
                })
            );
        }
    };

    useEffect(() => {
        //ReduxをuseStateに保存
        setTradeArea(listMpData);
    }, [listMpData]);

    useEffect(() => {
        const res: any = localStorage.getItem("codeMaster");
        if (res) {
            const d = JSON.parse(res);
            setYesnoneKana(d['common_yesnone_kana'])
        }
    }, []);

    //実査なしかつ更新フラグがあり場合、実査項目を全て空白して実査なしの計算を画面に反映
    useEffect(() => {
        if (objLocationBase.trade_area_reality_flag === "0" &&
            objLongPageSaveStatus.LongPage === true
        ) {
            dispatch(setTradeAreaMpData(mpData(listMpData, objLocationBase.trade_area_reality_flag)));
        }
    },[objLocationBase.trade_area_reality_flag])

    // 吹き出しをクリックしたとき、モーダル画面を開く
    const handleChatBubbleClick = (labelName: string) => {
        setLabelNameStr(labelName);
        setDeficiencyComentModalFlag(true);
        setTradeAreaMpDataCommentTextFieldObj({
        ...tradeAreaMpDataCommentTextFieldObj,
        [labelName]: "",
        }); //テキストフィールドのコメントを初期化
    };

    // 鉛筆をクリックしたとき、Input編集可
    const handleEditIconClick = (labelName: string) => {
        if (
            setPermissionFunc(
                userType,
                objLocationBase.task_id,
                LOCAL_CONSTANT.NAVI.TRADE_AREA,
                labelName
            ) === false
        ) {
            //falseにすると、Input編集可
            setTradeAreaMpDataReadOnlyObj({
                ...tradeAreaMpDataReadOnlyObj,
                [labelName]: false,
            });
        }
    };

    // モーダル内でのコメント取得
    const handleCommentChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        setTradeAreaMpDataCommentTextFieldObj({
            ...tradeAreaMpDataCommentTextFieldObj,
            [labelName]: e.target.value,
        });
    };

    // モーダル内の保存ボタンをクリックしたとき不備コメントを保存
    const handleSaveComment = async (labelName: string) => {
        //不備コメントを登録
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/regist",
            query: {
                plan_area_id: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                status_seq: objLocationBase.status_seq,
                table_name: LOCAL_CONSTANT.TABLE.TRADE_AREA,
                column_name: labelName,
                comment: tradeAreaMpDataCommentTextFieldObj[labelName],
                sub_key: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY
            },
        };
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.TRADE_AREA_COMMENT,
            params,
            user
        );
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            await apiRequest(params);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //モーダルを閉じる
            setDeficiencyComentModalFlag(false);
        } catch (e) {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //モーダルを閉じる
            setDeficiencyComentModalFlag(false);
        }
    };

    // 実査ありなしのプルダウン
    const handleSelectRealityFlag= (e: SelectChangeEvent<string>) => {
        dispatch(setTradeAreaRealityFlag(e.target.value));
        dispatch(setTradeAreaMpData(mpData(listMpData, e.target.value)));

        //更新フラグ
        if (!objLongPageSaveStatus.LongPage)
            dispatch(
                setSaveStatus({ ...objLongPageSaveStatus, LongPage: true, TradeArea: true })
            );
    };

    return (
        <Box>
            <Typography component="h2" mt={2}>
                ③勾配加味徒歩5分商圏
            </Typography>

            <TableContainer>
                <Table sx={table12Column}>
                    <TableHead>
                        {/* ヘッダー */}
                        <TableRow>
                            {GradientWalk5MinHeaderFirstColumns.map(
                                (column, index) => (
                                    <TableCell key={index} sx={labelStyle}>
                                        {lineBreak(column.label)}
                                    </TableCell>
                                )
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* データ */}
                        <TableRow>
                            {/* 商圏世帯数      ④商圏内データのテーブル 実査世帯数の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {calculateColumnTotal("reality_survey_household_count", tradeArea, objLocationBase.trade_area_reality_flag).toLocaleString()}
                            </TableCell>
                            {/* 単身世帯数      ④商圏内データのテーブル 単身世帯数の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("singleHousehold", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/* 単身比率        単身世帯数 / 商圏世帯数 * 100 */}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("singleHousehold", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("reality_survey_household_count", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* 人口            ④商圏内データのテーブル 人口の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("population", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/* 20代計          ④商圏内データのテーブル 20代の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("ageGroup20", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/* 20代比率        20代計 / 人口 * 100 */}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("ageGroup20", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("population", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* 30代計          ④商圏内データのテーブル 30代の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("ageGroup30", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/* 30代比率        30代計 / 人口 * 100 */}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("ageGroup30", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("population", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* 50歳以上計       ④商圏内データのテーブル 50上の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("ageGroup50", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/* 50歳以上比率     50歳以上計 / 人口 * 100 */}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("ageGroup50", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("population", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* 65歳以上計       ④商圏内データのテーブル 65上の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("ageGroup65More", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/* 65歳以上比率     65歳以上計 / 人口 * 100 */}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("ageGroup65More", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("population", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer>
                <Table sx={table6Column}>
                    <TableHead>
                        {/* ヘッダー */}
                        <TableRow>
                            {GradientWalk5MinHeaderSecondColumns.map(
                                (column, index) => (
                                    <TableCell key={index} sx={labelStyle}>
                                        {lineBreak(column.label)}
                                    </TableCell>
                                )
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {/*  事業所       ④商圏内データのテーブル 実査事業所の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("reality_survey_office", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/*  従業員数     ④商圏内データのテーブル 実査就業者の合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("reality_survey_employed_workers", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/*  引分事業所    proration_retail_countを④商圏内データのテーブルの各レコードに紐づけてその合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("proration_retail_count", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/*  引分従業員    proration_retail_employees_countを④商圏内データのテーブルの各レコードに紐づけてその合計 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(calculateColumnTotal("proration_retail_employees_count", tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                            </TableCell>
                            {/*  差引事業所    事業所-引分事業所 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(Number(calculateColumnTotal("reality_survey_office", tradeArea, objLocationBase.trade_area_reality_flag)) - Number(calculateColumnTotal("proration_retail_count", tradeArea, objLocationBase.trade_area_reality_flag))).toLocaleString()}
                            </TableCell>
                            {/*  差引従業員    従業員数-引分従業員 */}
                            <TableCell sx={tableCellStyle}>
                                {Math.round(Number(calculateColumnTotal("reality_survey_employed_workers", tradeArea, objLocationBase.trade_area_reality_flag)) - Number(calculateColumnTotal("proration_retail_employees_count", tradeArea, objLocationBase.trade_area_reality_flag))).toLocaleString()}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer>
                <Table sx={table5Column}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={labelHeaderStyle}></TableCell>
                            <TableCell sx={labelHeaderStyle}></TableCell>
                            <TableCell sx={labelHeaderStyle}>年収階級</TableCell>
                            <TableCell sx={labelHeaderStyle}></TableCell>
                            <TableCell sx={labelHeaderStyle}></TableCell>
                        </TableRow>
                        {/* ヘッダー */}
                        <TableRow>
                            {GradientWalk5MinHeaderThirdColumns.map(
                                (column, index) => (
                                    <TableCell key={index} sx={labelStyle}>
                                        {lineBreak(column.label)}
                                    </TableCell>
                                )
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            {/* ～300万 */}
                            {/* income_up_to_300、income_up_to_500、income_up_to_700、income_up_to_1000、income_over1000を④商圏内データのテーブルの各レコードに紐づけた合計をさらに全項目（300～over1000）で合計を計算 income_up_to_300のレコード合計/上記の全合計*100   %表記なので最後に100かける*/}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("income_up_to_300", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("incomeSum", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* ～500万 */}
                            {/* income_up_to_300、income_up_to_500、income_up_to_700、income_up_to_1000、income_over1000を④商圏内データのテーブルの各レコードに紐づけた合計をさらに全項目（300～over1000）で合計を計算 income_up_to_500のレコード合計/上記の全合計*100 　%表記なので最後に100かける*/}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("income_up_to_500", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("incomeSum", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* ～700万 */}
                            {/* income_up_to_300、income_up_to_500、income_up_to_700、income_up_to_1000、income_over1000を④商圏内データのテーブルの各レコードに紐づけた合計をさらに全項目（300～over1000）で合計を計算 income_up_to_700のレコード合計/上記の全合計*100 　%表記なので最後に100かける*/}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("income_up_to_700", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("incomeSum", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* ～1000万 */}
                            {/* income_up_to_300、income_up_to_500、income_up_to_700、income_up_to_1000、income_over1000を④商圏内データのテーブルの各レコードに紐づけた合計をさらに全項目（300～over1000）で合計を計算 income_up_to_1000のレコード合計/上記の全合計*100  %表記なので最後に100かける*/}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("income_up_to_1000", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("incomeSum", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                            {/* 1000万～ */}
                            {/* income_up_to_300、income_up_to_500、income_up_to_700、income_up_to_1000、income_over1000を④商圏内データのテーブルの各レコードに紐づけた合計をさらに全項目（300～over1000）で合計を計算 income_over1000のレコード合計/上記の全合計*100 　 %表記なので最後に100かける*/}
                            <TableCell sx={tableCellStyle}>
                                {(Math.round(divideIfNotZero(Number(calculateColumnTotal("income_over1000", tradeArea, objLocationBase.trade_area_reality_flag)), Number(calculateColumnTotal("incomeSum", tradeArea, objLocationBase.trade_area_reality_flag))) * 100 * 100) / 100).toFixed(2)}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <Typography component="h2" mt={2}>
                ④商圏内データ
            </Typography>

            <TableContainer>
                <Table sx={table3Column}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={labelStyle}></TableCell>
                            <TableCell sx={labelStyle}>商圏密度</TableCell>
                            <TableCell sx={labelStyle}>立地</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={labelStyle}>修正前</TableCell>
                            <TableCell sx={tableCellStyle}>
                                {tradeAreaDensityFunc("beforeModified", tradeArea)}
                            </TableCell>
                            <TableCell sx={tableCellStyle}>
                                {locationFunc("beforeModified", tradeArea)}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell sx={labelStyle}>修正後</TableCell>
                            <TableCell sx={tableCellStyle}>
                                {tradeAreaDensityFunc("afterModified", tradeArea)}
                            </TableCell>
                            <TableCell sx={tableCellStyle}>
                                {locationFunc("afterModified", tradeArea)}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer>
                <Table sx={table13Column}>
                    <TableHead>
                        {/* ヘッダー */}
                        <TableRow>
                            {TaradeAreaHeaderColumns.map((column) => (
                                <TableCell key={column.colName} sx={labelStyle}>
                                    {lineBreak(column.label)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* 合計 */}
                        <TableRow>
                            <TableCell sx={labelStyle}>合計</TableCell>
                            {TaradeAreaSumColumns.map((column) => (
                                <TableCell key={column.colName} sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        value={Math.round(calculateColumnTotal(column.colName, tradeArea, objLocationBase.trade_area_reality_flag)).toLocaleString()}
                                        sx={TextFieldSx}
                                        variant="outlined"
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ padding: "20px 10px" }}>実査</Typography>
                <Select
                    onChange={(e) => handleSelectRealityFlag(e)}
                    value={objLocationBase.trade_area_reality_flag}
                    disabled={setPermissionFunc(
                        userType,
                        objLocationBase.task_id,
                        LOCAL_CONSTANT.NAVI.TRADE_AREA,
                        "trade_area_reality_flag"
                    )}
                >
                    {
                        yesnoneKana?.map((row: any) => (
                            <MenuItem key={row.code_value} value={row.code_value}>{row.code_display}</MenuItem>
                        ))
                    }
                </Select>
            </Box>

            <TableContainer sx={{ display: "flex" }}>
                <Table sx={objLocationBase.trade_area_reality_flag === "1" ? table13Column : table10Column}>                
                    <TableHead>
                        {/* ヘッダー */}
                        <TableRow>
                            {TaradeAreaHeaderColumns.map((column) => (
                                column.tradeAreaRealityFlag.includes(objLocationBase.trade_area_reality_flag) &&
                                    <TableCell key={column.colName} sx={labelStyle}>
                                        {lineBreak(column.label)}
                                    </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* データ */}
                        {tradeArea.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {/* 町丁字 */}
                                <TableCell sx={tableCellStyle}>
                                    {row.townDistrict}
                                </TableCell>
                                {/* 世帯数:(世帯) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.residences_count)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 実査 項目ありの場合 実査:世帯数を表示*/}
                                {objLocationBase.trade_area_reality_flag === "1" &&
                                    <TableCell sx={tableCellStyle}>
                                        <TextField
                                            fullWidth
                                            disabled={
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                                        "actual_survey_trade_area_data"
                                                    )
                                                    : tradeAreaMpDataReadOnlyObj.actual_survey_trade_area_data
                                            }
                                            sx={tableActiveInactiveTextSx(
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                                        "actual_survey_trade_area_data"
                                                    )
                                                    : tradeAreaMpDataReadOnlyObj.actual_survey_trade_area_data,
                                                objRrBranchLog,
                                                "reality_survey_household_count",
                                                row.reality_survey_household_count,
                                                row.trade_area_seq
                                            )}
                                            value={row.reality_survey_household_count}
                                            onChange={(e) => handleCellChange(e, rowIndex, "reality_survey_household_count")}
                                            onBlur={(e) => handleCellBlur(e, rowIndex, "reality_survey_household_count", objLocationBase.trade_area_reality_flag)}
                                            variant="outlined"
                                        />
                                    </TableCell>
                                }
                                {/* 単身世帯:(世帯) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.singleHousehold)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 人口:(人) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.population)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 20代:(人) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.ageGroup20)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 30代:(人) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.ageGroup30)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 50代:(人) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.ageGroup50)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 65上:(人)" */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.ageGroup65More)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 事業所:(箇所) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.office)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 従業員:(人) */}
                                <TableCell sx={tableCellStyle}>
                                    <TextField
                                        disabled
                                        fullWidth
                                        sx={TextFieldSx}
                                        value={Math.round(Number(row.employees)).toLocaleString()}
                                        variant="outlined"
                                    />
                                </TableCell>
                                {/* 実査 項目ありの場合 実査:事業所を表示 */}
                                {objLocationBase.trade_area_reality_flag === "1" &&
                                    <TableCell sx={tableCellStyle}>
                                        <TextField
                                            fullWidth
                                            disabled={
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                                        "actual_survey_trade_area_data"
                                                    )
                                                    : tradeAreaMpDataReadOnlyObj.actual_survey_trade_area_data
                                            }
                                            sx={tableActiveInactiveTextSx(
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                                        "actual_survey_trade_area_data"
                                                    )
                                                    : tradeAreaMpDataReadOnlyObj.actual_survey_trade_area_data,
                                                objRrBranchLog,
                                                "reality_survey_office",
                                                row.reality_survey_office,
                                                row.trade_area_seq
                                            )}
                                            value={row.reality_survey_office}
                                            onChange={(e) => handleCellChange(e, rowIndex, "reality_survey_office")}
                                            onBlur={(e) => handleCellBlur(e, rowIndex, "reality_survey_office", objLocationBase.trade_area_reality_flag)}
                                            variant="outlined"
                                        />
                                    </TableCell>
                                }
                                {/* 実査 項目ありの場合 実査:就業者を表示 */}
                                {objLocationBase.trade_area_reality_flag === "1" && 
                                    <TableCell sx={tableCellStyle}>
                                        <TextField
                                            fullWidth
                                            disabled={
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                                        "actual_survey_trade_area_data"
                                                    )
                                                    : tradeAreaMpDataReadOnlyObj.actual_survey_trade_area_data
                                            }
                                            sx={tableActiveInactiveTextSx(
                                                userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                                        "actual_survey_trade_area_data"
                                                    )
                                                    : tradeAreaMpDataReadOnlyObj.actual_survey_trade_area_data,
                                                objRrBranchLog,
                                                "reality_survey_employed_workers",
                                                row.reality_survey_employed_workers,
                                                row.trade_area_seq
                                            )}
                                            value={row.reality_survey_employed_workers}
                                            onChange={(e) => handleCellChange(e, rowIndex, "reality_survey_employed_workers")}
                                            onBlur={(e) => handleCellBlur(e, rowIndex, "reality_survey_employed_workers", objLocationBase.trade_area_reality_flag)}
                                            variant="outlined"
                                        />
                                    </TableCell>
                                }
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                    <Grid sx={{ width: "200px" }}>
                        <IconButton
                            disabled={setPermissionFunc(
                                userType,
                                objLocationBase.task_id,
                                LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                "actual_survey_trade_area_data"
                            )}
                            onClick={() => {handleChatBubbleClick("actual_survey_trade_area_data");}}
                            sx={iconHover}
                        >
                            <Box
                                sx={chatBubbleErrorSx(
                                    userType,
                                    objLocationBase.task_id,
                                    LOCAL_CONSTANT.NAVI.TRADE_AREA,
                                    "actual_survey_trade_area_data",
                                    listDeficiencyComment
                                )}
                            >
                                <ChatBubbleIcon sx={chatBubbleIconSx} />
                            </Box>
                        </IconButton>
                        {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                            <IconButton
                                onClick={() => {handleEditIconClick("actual_survey_trade_area_data");}}
                                sx={iconHover}
                            >
                                <Box sx={editIconCircleSx}>
                                    <EditIcon />
                                </Box>
                            </IconButton>
                        )}
                    </Grid>
                )}
            </TableContainer>

            {/*不備コメント モーダル画面(プルダウン、ラジオボタン) */}
            <DeficiencyCommentRegistModal
                props={{
                    userType: userType,
                    modalOpen: deficiencyComentModalFlag,
                    setModalOpen: setDeficiencyComentModalFlag,
                    CommentTextFieldObj: tradeAreaMpDataCommentTextFieldObj,
                    tableName: LOCAL_CONSTANT.TABLE.TRADE_AREA,
                    columnName: labelNameStr,
                    subKey: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY,
                    handleCommentChange: handleCommentChange,
                    handleSaveComment: handleSaveComment,
                }}
            />
        </Box>
    );
};

export default TradeAreaMpData;
